import React from 'react'
import {formatInZone, zoneNotice} from 'helpers/datetime'
import {Col, Row, List, Tag, Typography} from 'antd'
import {Spin} from 'antd'
import {useMutation, useQuery} from 'react-query'

import Item from './Item'
import * as reportQueries from '../../../queries/report.queries'
import * as Styled from './counterview.styled'
import Link from 'components/SafeLink'

const {Title} = Typography

function ReportView({params}) {
    const reportQuery = useQuery(['id', params.id], reportQueries.getReportById)

    const report = reportQuery.data?.data.data

    /* G40-456: render this record's times on the clock they belong to — the
       order's, supplied by the API, or the operator's when the record has no
       order behind it. `zoneLine` names which, and says when it was inferred. */
    const fmt = (value, options = {}) =>
        formatInZone(value, report?.order_timezone, options)
    const zoneLine = zoneNotice(
        report?.order_timezone,
        report?.order_timezone_source,
    )
    if (reportQuery.isLoading) {
        return (
            <Styled.Root>
                <Spin />
            </Styled.Root>
        )
    }

    return (
        <>
            {/* G40-456 zone caption — say whose clock these times are on */}
            <div
                style={{
                    fontSize: '85%',
                    opacity: 0.75,
                    margin: '0 0 10px 8px',
                }}>
                {zoneLine}
            </div>
            <div className="order">
                <Col style={{width: '100%'}}>
                    <List
                        size="small"
                        bordered
                        style={{background: 'rgba(0,0,0,0.03)'}}
                        header={<Title level={5}>Basic Info</Title>}>
                        <Item
                            body={
                                <Link to={`/reports/${report.id}`}>
                                    {report.id}
                                </Link>
                            }
                            title="Id "
                        />
                        <Item
                            body={
                                <Link to={`/user/${report.reporter_id}`}>
                                    {report.reporter_name}
                                </Link>
                            }
                            title="Reporter Name"
                        />
                        {report?.app_bug == false ? (
                            <Item
                                body={
                                    report.order_id ? (
                                        <Link
                                            to={`/booking/${report.order_id}`}>
                                            {report.order_id}
                                        </Link>
                                    ) : (
                                        'N/A'
                                    )
                                }
                                title="Order Id "
                            />
                        ) : (
                            <></>
                        )}
                        {report?.app_bug ? (
                            <Item body={report.os_version} title="Os version" />
                        ) : (
                            <></>
                        )}
                        {report?.app_bug ? (
                            <Item
                                body={report.app_version}
                                title="App version"
                            />
                        ) : (
                            <></>
                        )}
                        {report?.app_bug ? (
                            <Item body={report.model_name} title="Model name" />
                        ) : (
                            <></>
                        )}
                        {report?.app_bug ? (
                            <Item body={report.app_type} title="App Type" />
                        ) : (
                            <></>
                        )}
                        {report?.app_bug ? (
                            <Item
                                body={report.attachments_count}
                                title="Total Attachments"
                            />
                        ) : (
                            <></>
                        )}
                        {report?.attachment?.length ? (
                            report?.attachment?.map(item => {
                                return (
                                    <a
                                        style={{
                                            marginRight: 15,
                                            marginLeft: 15,
                                        }}
                                        href={item}
                                        target="_blank">
                                        View
                                    </a>
                                )
                            })
                        ) : (
                            <></>
                        )}
                        <Item
                            body={report.description || 'N/A'}
                            title="Description"
                        />

                        <Item
                            body={
                                fmt(report.created_at, {withParens: true}) ||
                                'N/A'
                            }
                            title="Created On"
                        />

                        <Item
                            body={
                                fmt(report.updated_at, {withParens: true}) ||
                                'N/A'
                            }
                            title="Updated On"
                        />
                    </List>
                </Col>
            </div>
        </>
    )
}

export default ReportView
